import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";

import { useMainStore } from "@/contexts/Store";

import NewSectionTag from "../shared/NewSectionTag";
import SectionDragContext from "../shared/SectionDragContext";
import RiskRegisterSection from "./RiskRegisterSection";

type Props = {
  moduleWorkspaceID: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fields?: any; // TODO: PropTypes.instanceOf(Array)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialSection?: any; // TODO: PropTypes.instanceOf(Object)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  recordVersions?: any; // TODO: PropTypes.instanceOf(Array)
  loading: boolean;
};

function RiskRegistersTable({
  fields,
  recordVersions,
  moduleWorkspaceID,
  initialSection,
  loading,
}: Props) {
  // Import MobX stores
  const mainStore = useMainStore();
  const sectionTags = mainStore.sectionTags.orderedList;

  // State
  const [showNewSectionDetails, setShowNewSectionDetails] = useState(false);

  // Effects
  useEffect(() => {
    // Hide "Add New Section" button when on a section
    if (
      mainStore.sectionTags.current &&
      Object.keys(mainStore.sectionTags.current).length !== 0
    ) {
      setShowNewSectionDetails(false);
    }
  }, [mainStore.sectionTags.current]);

  // Variables
  const { canManageSections } = mainStore.userPermissions;
  const deactivatedFields = [
    "finalize:title",
    "finalize:date",
    "finalize:approver",
  ];
  const filteredFields = fields.filter(
    // @ts-expect-error TS(7006) FIXME: Parameter 'item' implicitly has an 'any' type.
    (item) => !deactivatedFields.includes(item.computed_column_identifier),
  );
  const currentSection =
    initialSection || mainStore.riskRegisters.currentSection;
  const onAllRisksPage = !currentSection?.id;

  // Functions
  function addNewSectionClick() {
    setShowNewSectionDetails(!showNewSectionDetails);
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'recordVersionId' implicitly has an 'any... Remove this comment to see the full error message
  const onSectionChange = (recordVersionId, sectionId) => {
    mainStore.creatives.updateSection(recordVersionId, sectionId);
  };

  return (
    <div
      className="table-list-wrap-virtual"
      data-testid="module-sections-container"
    >
      <SectionDragContext onSectionChange={onSectionChange}>
        {sectionTags.map((sectionTag) => {
          // If on a section page (currentSection exists), skip other sections
          if (currentSection?.id && currentSection.id !== sectionTag.id) {
            return null;
          }

          const filteredRecordVersions = recordVersions.filter(
            // @ts-expect-error TS(7006) FIXME: Parameter 'recordVersion' implicitly has an 'any' ... Remove this comment to see the full error message
            (recordVersion) => recordVersion.section_tag_id === sectionTag.id,
          );

          return (
            <RiskRegisterSection
              key={sectionTag.id}
              isDropdownOpen
              tableName=""
              fields={filteredFields}
              recordVersions={filteredRecordVersions}
              moduleWorkspaceID={moduleWorkspaceID}
              isDragAndDrop={false}
              sectionTag={sectionTag}
              currentScreen=""
              loading={loading}
              pageID={sectionTag.id}
            />
          );
        })}

        {showNewSectionDetails && (
          <NewSectionTag moduleWorkspaceID={moduleWorkspaceID} />
        )}

        {fields.length > 0 && onAllRisksPage && canManageSections && (
          <div className="create-new-record add-procedures-section">
            <button onClick={addNewSectionClick}>Add New Section +</button>
          </div>
        )}
      </SectionDragContext>
    </div>
  );
}

RiskRegistersTable.defaultProps = {
  recordVersions: [],
  fields: [],
};

export default observer(RiskRegistersTable);
